import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IAppState, FollowUpActionCreators, IFollowUpSurveyListResponse } from '@nkr/store/index';
import { followUpSurveyListTypeMap, IBaseResponse, ICenterBase, IFollowUpSurveyForList, IFollowUpSurveyShow } from '@nkr/models/index';
import { FollowUpSurveyListType } from '@nkr/enums/index';
import { SurveyAction } from './survey-action';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { downloadFile } from '@nkr/services/download-file';
import CenterSurveyList from './center-list';
import AdminSurveyList from './admin-list';
import Search from './search';
import UploadLabOrders from '../upload-lab-orders';
import MarkIncomplete from '../mark-incomplete';
import MarkAppointmentBooked from '../mark-appointment-booked';
import ResendSurveyEmail from '../resend-survey-email';
import MarkOrdersSent from '../mark-orders-sent';

interface IProps {
    centerId: number,
    activeKey: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    itemId?: number,
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getFollowUpSurveyList: (listType: FollowUpSurveyListType, centerId: number, firstName: string, lastName: string, startDate: string, endDate: string, show: IFollowUpSurveyShow) => Promise<IFollowUpSurveyListResponse>,
    markIncomplete: (id: number) => Promise<IBaseResponse>,
    markOrdersSent: (id: number) => Promise<IBaseResponse>,
    appointmentBooked: (id: number) => Promise<IBaseResponse>,
    uploadLabOrders: (id: number, file: File) => Promise<IBaseResponse>,
    sendSurveyEmail: (id: number) => Promise<IBaseResponse>,
    getSurveyPdf: (id: number) => Promise<any>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: IFollowUpSurveyForList[],
    listType: FollowUpSurveyListType,
    firstName: string,
    lastName: string,
    startDate: string,
    endDate: string,
    center: number,
    show: IFollowUpSurveyShow,
    uploadLabOrders: {
        show: boolean,
        data: IFollowUpSurveyForList
    },
    confirmMarkIncomplete: {
        show: boolean,
        data: IFollowUpSurveyForList
    },
    confirmMarkOrdersSent: {
        show: boolean,
        data: IFollowUpSurveyForList
    },
    confirmAppointmentBooked: {
        show: boolean,
        data: IFollowUpSurveyForList
    },
    confirmResendSurveyEmail: {
        show: boolean,
        data: IFollowUpSurveyForList
    },
    isLoading: boolean
}

class FollowUpSurveyList extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        listType: FollowUpSurveyListType.Unknown,
        firstName: '',
        lastName: '',
        startDate: '',
        endDate: '',
        center: 0,
        show: {
            show6Month: true,
            show12Month: true,
            show24Month: true,
            showOtherMonths: false
        },
        uploadLabOrders: {
            show: false,
            data: null
        },
        confirmMarkIncomplete: {
            show: false,
            data: null
        },
        confirmMarkOrdersSent: {
            show: false,
            data: null
        },
        confirmAppointmentBooked: {
            show: false,
            data: null
        },
        confirmResendSurveyEmail: {
            show: false,
            data: null
        },
        isLoading: true
    }

    gridApi: GridApi;
    columnApi: ColumnApi;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.columnApi = e.columnApi;
    }

    componentDidMount = () => {
        let { centerId: center } = this.props;

        let show = _.cloneDeep(this.state.show);
        
        let parsedCenterId = null;

        if (this.isValidNumber(center)) {
            parsedCenterId = parseInt(center.toString());
        }

        if (this.getListType() == FollowUpSurveyListType.All) {
            show.showOtherMonths = true;
        }

        this.setState({
            show,
            center: parsedCenterId
        }, () => {
            this.getData();
        });
    }

    getListType = () => {
        let item = followUpSurveyListTypeMap.find(x => x.url == this.props.activeKey.toLowerCase());

        if (item != null) {
            return item.type;
        }

        return FollowUpSurveyListType.AllToDo;
    }

    getData = () => {
        let { center, firstName, lastName, startDate, endDate, show } = this.state;
        let listType = this.getListType();      

        if (center == 0) {
            center = null;
        }

        this.props.showLoading('Getting list of surveys, one moment please...').then(async () => {
            let response = await this.props.getFollowUpSurveyList(listType, center, firstName, lastName, startDate, endDate, show);

            if (response.data.success) {
                let list = response.data.results;
                let isLoading = list.length == 0 ? false : true;
                             
                this.setState({
                    list,
                    isLoading,
                    listType
                }, () => {
                    this.props.hideLoading();
                });
            }
        });
    }

    getCenterList = () => {
        let results: ICenterBase[] = [];

        for (let n = 0; n < this.state.list.length; n++) {
            let item = this.state.list[n];
            let exists = results.find(x => x.id == item.centerId);

            if (exists == null) {
                results.push({
                    id: item.centerId,
                    alias: item.centerAlias,
                    name: '',
                    isMemberCenter: true,
                    centerAddresses: []
                });
            }
        }

        return _.orderBy(results, (item) => {
            return item.alias
        }, 'asc');
    }

    getSurveyPdf = (id: number) => {
        this.props.showLoading('Getting financial info, one moment please...').then(() => {
            this.props.getSurveyPdf(id).then((response: any) => {
                this.props.hideLoading();

                downloadFile(response.data, `survey-details-${id}.pdf`, 'application/pdf');
            });
        });
    }

    handleSearchChange = (center: number, firstName: string, lastName: string, startDate: string, endDate: string, show: IFollowUpSurveyShow) => {
        this.setState({
            center,
            firstName,
            lastName,
            startDate,
            endDate,
            show
        });
    }

    handleSearch = () => {
        this.getData();
    }

    handleResetSearch = () => {
        let show = {
            show6Month: true,
            show12Month: true,
            show24Month: true,
            showOtherMonths: false
        };

        this.setState({
            center: 0,
            firstName: '',
            lastName: '',
            startDate: '',
            endDate: '',
            show
        }, () => {
            this.getData();
        });
    }

    handleLoadingComplete = () => {
        this.setState({
            isLoading: false
        });
    }

    handleExport = () => {
        // let listType = micrositeListTypeMap.find(x => x.url == this.props.activeKey.toLowerCase());

        // let excludedColumns = ['isSelected', 'rowNumber'];
        // // let c = this.gridApi.getColumnDefs().filter(x=>x.hi).map(x => x['colId']).filter(colId => excludedColumns.indexOf(colId) < 0);

        // let c = this.columnApi.getAllDisplayedColumns().map(x => x.getColId()).filter(colId => excludedColumns.indexOf(colId) < 0);

        // let params: CsvExportParams = {
        //     columnGroups: true,
        //     fileName: `microsites-${listType.name.toLowerCase()}.csv`,
        //     columnKeys: c,
        //     processCellCallback: (params: ProcessCellForExportParams) => {
        //         // let colDef = params.column.getColDef();

        //         // if (colDef.colId == 'centerAlias') {
        //         //     if (params.node.data.centerAlias == '') {
        //         //         return 'Totals';
        //         //     }
        //         // }

        //         return params.value;
        //     }
        // };

        // this.gridApi.exportDataAsCsv(params);
    }

    handleItemSelected = (id: number, action: SurveyAction) => {
        let data = this.state.list.find(x => x.id == id);
        let dashDomain = data.dashDomain.replace('.org', __HIGH_LEVEL_DASH_DOMAIN__);

        switch (action) {
            case SurveyAction.UploadRequisition:
                this.setState({
                    uploadLabOrders: {
                        show: true,
                        data
                    }
                });

                break;

            case SurveyAction.FollowUpUnsuccessful:
                this.setState({
                    confirmMarkIncomplete: {
                        show: true,
                        data
                    }
                });

                break;

            case SurveyAction.RequisionAlreadySent:
                this.setState({
                    confirmMarkOrdersSent: {
                        show: true,
                        data
                    }
                });

                break;

            case SurveyAction.MarkAppointmentBooked:
                this.setState({
                    confirmAppointmentBooked: {
                        show: true,
                        data
                    }
                });

                break;

            case SurveyAction.ResendSurveyEmail:
                this.setState({
                    confirmResendSurveyEmail: {
                        show: true,
                        data
                    }
                });

                break;

            case SurveyAction.PhoneInterviewSurvey:
                window.open(`https://${dashDomain}/follow-up/survey/${id}/${data.editKey}`, '_blank');

                break;

            case SurveyAction.GetPDF:
                this.getSurveyPdf(id);
                break;
        }
    }

    handleUploadLabOrders = (file: File) => {
        let id = this.state.uploadLabOrders.data.id;

        this.setState({
            uploadLabOrders: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                this.props.uploadLabOrders(id, file).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Successfully updated survey');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelUploadLabOrders = () => {
        this.setState({
            uploadLabOrders: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmMarkIncomplete = () => {
        let id = this.state.confirmMarkIncomplete.data.id;

        this.setState({
            confirmMarkIncomplete: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                this.props.markIncomplete(id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Successfully updated survey');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelMarkIncomplete = () => {
        this.setState({
            confirmMarkIncomplete: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmMarkOrdersSent = () => {
        let id = this.state.confirmMarkOrdersSent.data.id;

        this.setState({
            confirmMarkOrdersSent: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                this.props.markOrdersSent(id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Successfully updated survey');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelMarkOrdersSent = () => {
        this.setState({
            confirmMarkOrdersSent: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmAppointmentBooked = () => {
        let id = this.state.confirmAppointmentBooked.data.id;

        this.setState({
            confirmAppointmentBooked: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating survey, one moment please...').then(() => {
                this.props.appointmentBooked(id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Successfully updated survey');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelAppointmentBooked = () => {
        this.setState({
            confirmAppointmentBooked: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmResendSurveyEmail = () => {
        let id = this.state.confirmResendSurveyEmail.data.id;

        this.setState({
            confirmResendSurveyEmail: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Resending survey email, one moment please...').then(() => {
                this.props.sendSurveyEmail(id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('Email successfully sent');

                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelResendSurveyEmail = () => {
        this.setState({
            confirmResendSurveyEmail: {
                show: false,
                data: null
            }
        });
    }

    renderAlert = () => {
        let message = '';

        switch (this.state.listType) {
            case FollowUpSurveyListType.AllToDo: message = 'Surveys requiring action. Excludes "Pending Lab Results" since that is pending the donor to an extent.'; break;
            case FollowUpSurveyListType.PendingAll: message = 'All donors except completed donors.'; break;
            case FollowUpSurveyListType.PendingSurvey: message = 'No Action Required. Donors remain in this tab until they complete the survey and choose lab preference.'; break;
            case FollowUpSurveyListType.PendingReview: message = 'Donors here may also show up in other tabs.  They will show up in this tab until their survey answers are marked as reviewed.'; break;
            case FollowUpSurveyListType.PendingAppointment: message = 'Donors here want to schedule an appointment at your center to do labs. Once you have contacted them and arranged an appointment, you can click "Mark Appointment Booked" from the Actions button.'; break;
            case FollowUpSurveyListType.PendingLabOrder: message = 'Donors here are waiting for you to upload lab orders for Quest or LabCorp. Once you upload the orders, we will send the donor a link to the lab orders via e-mail.'; break;
            case FollowUpSurveyListType.PendingLabResults: message = 'Donors here have an appointment at your center or have lab orders for Quest/LabCorp. Once you have the results and consult with the donor, click "Mark Complete" from the Actions button.'; break;
            case FollowUpSurveyListType.CompleteNoResults: message = 'Donors here have indicated when and where they completed their labs, but you have not yet indicated that they are complete. Once you have the results and consult with the donor, click "Mark Complete" from the Actions button.'; break;
        }

        if (message != '') {
            return <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>{message}</Alert>
        }

        return null;
    }

    isValidNumber = str => str != null && str !== '' && !isNaN(str);

    render = () => {

        const centerList = this.getCenterList();      
        const filteredList = this.state.center > 0? this.state.list.filter(item => item.centerId === this.state.center): this.state.list;

        return (
            <>
                {this.renderAlert()}

                <Search
                    listType={this.state.listType}
                    centerId={this.state.center}
                    firstName={this.state.firstName}
                    lastName={this.state.lastName}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    show={this.state.show}
                    isAdmin={this.props.isAdmin}
                    centerList={centerList}
                    onChange={this.handleSearchChange}
                    onSearch={this.handleSearch}
                    onReset={this.handleResetSearch}
                />

                {!this.props.isAdmin && (
                    <div style={{ width: "100%", paddingTop: 0, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                        <CenterSurveyList
                            isAdminLogin={this.props.isAdminLogin}
                            centerId={this.props.centerId}
                            listType={this.state.listType}
                            list={filteredList}
                            isLoading={this.state.isLoading}
                            onLoadingComplete={this.handleLoadingComplete}
                            onGridReady={this.onGridReady}
                            onItemSelected={this.handleItemSelected}
                        />
                    </div>
                )}

                {this.props.isAdmin && (
                    <div style={{ width: "100%" }}>
                        <AdminSurveyList
                            centerId={this.props.centerId}
                            listType={this.state.listType}
                            list={filteredList}
                            isLoading={this.state.isLoading}
                            onLoadingComplete={this.handleLoadingComplete}
                            onGridReady={this.onGridReady}
                            onItemSelected={this.handleItemSelected}
                        />

                        <div>{this.state.list.length} survey(s) shown...</div>
                    </div>
                )}

                <UploadLabOrders
                    show={this.state.uploadLabOrders.show}
                    data={this.state.uploadLabOrders.data}
                    onUpload={this.handleUploadLabOrders}
                    onCancel={this.handleCancelUploadLabOrders}
                />

                <MarkIncomplete
                    show={this.state.confirmMarkIncomplete.show}
                    data={this.state.confirmMarkIncomplete.data}
                    onConfirm={this.handleConfirmMarkIncomplete}
                    onCancel={this.handleCancelMarkIncomplete}
                />

                <MarkOrdersSent
                    show={this.state.confirmMarkOrdersSent.show}
                    data={this.state.confirmMarkOrdersSent.data}
                    onConfirm={this.handleConfirmMarkOrdersSent}
                    onCancel={this.handleCancelMarkOrdersSent}
                />

                <MarkAppointmentBooked
                    show={this.state.confirmAppointmentBooked.show}
                    data={this.state.confirmAppointmentBooked.data}
                    onConfirm={this.handleConfirmAppointmentBooked}
                    onCancel={this.handleCancelAppointmentBooked}
                />

                <ResendSurveyEmail
                    show={this.state.confirmResendSurveyEmail.show}
                    data={this.state.confirmResendSurveyEmail.data}
                    onConfirm={this.handleConfirmResendSurveyEmail}
                    onCancel={this.handleCancelResendSurveyEmail}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getFollowUpSurveyList: (listType, centerId, firstName, lastName, startDate, endDate, show) => {
            return dispatch(FollowUpActionCreators.getSurveyList(listType, centerId, firstName, lastName, startDate, endDate, show));
        },
        markIncomplete: (id) => {
            return dispatch(FollowUpActionCreators.markIncomplete(id));
        },
        markOrdersSent: (id) => {
            return dispatch(FollowUpActionCreators.markOrdersSent(id));
        },
        appointmentBooked: (id) => {
            return dispatch(FollowUpActionCreators.appointmentBooked(id));
        },
        uploadLabOrders: (id, file) => {
            return dispatch(FollowUpActionCreators.uploadLabOrders(id, file));
        },
        sendSurveyEmail: (id) => {
            return dispatch(FollowUpActionCreators.sendSurveyEmail(id));
        },
        getSurveyPdf: (id) => {
            return dispatch(FollowUpActionCreators.getSurveyPdf(id));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(FollowUpSurveyList);